<template>
  <v-alert
    colored-border
    :color="cardStyle.color"
    :icon="cardStyle.icon"
    border="top"
    elevation="2"
    prominent
  >
    <v-row v-if="loading" justify="center">
      <v-progress-circular indeterminate width="2"></v-progress-circular>
    </v-row>
    <div v-else>
      <div class="subheading grey--text text--darken-2">Messages Waiting</div>
      <div class="headline">{{ waitingIds }}</div>
    </div>
  </v-alert>
</template>

<script>
import { cardStyle } from '../lib/colors';

export default {
  props: {
    waitingIds: { type: Number },
    loading: { type: Boolean },
  },
  computed: {
    cardStyle() {
      return cardStyle(this.loading, this.waitingIds === 0);
    },
  },
};
</script>
